import Iconfont from '@utils/Iconfont';
import styles from "./index.module.scss"

export default function GoBack (props) {
    return (
        <div className={styles.GoBack} onClick={props.onClick}>
            <Iconfont type="icon-LeftOutlined" className={styles.Icon} />
            <span className={styles.Label}>返回</span>
        </div>
    )
}